import { render, staticRenderFns } from "./Mcatering.vue?vue&type=template&id=b1302252&scoped=true&"
import script from "./Mcatering.vue?vue&type=script&lang=js&"
export * from "./Mcatering.vue?vue&type=script&lang=js&"
import style0 from "./Mcatering.vue?vue&type=style&index=0&id=b1302252&scoped=true&lang=less&"
import style1 from "./Mcatering.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1302252",
  null
  
)

export default component.exports